<style scoped>
    .edit-line{
        padding: 0 80px;
        line-height: 24px;
    }
</style>
<template>
    <div>
        <div class="line">
            <Button type="primary" @click="editCourseDataType(new_course_data_type)" icon="md-add">添加课程</Button>
        </div>

        <Row class="line">
            <i-col span="11">
                <CourseDataTypeEdit
                        @edit="editCourseDataType"
                        :course_data_type="sub_type"
                        v-for="sub_type in level1_types"
                        :key="sub_type.id">
                </CourseDataTypeEdit>
            </i-col>
            <i-col span="13"></i-col>
        </Row>
        <!--<Table :columns="columns" :data="course_data_types"></Table>-->

        <Modal title="添加/编辑课程"
               width="500"
               v-model="edit_config.modal"
               :loading="edit_config.loading"
               @on-ok="updateCourseDataType"
               ok-text="确定">
            <Form ref="formInline" :model="edit_course_data_type" :label-width="60">
                <FormItem label="名称">
                    <i-input type="text" v-model="edit_course_data_type.name" placeholder="名称..."></i-input>
                </FormItem>
                <FormItem label="解释">
                    <i-input type="text" v-model="edit_course_data_type.name_tip" placeholder="名称解释..."></i-input>
                </FormItem>
                <FormItem label="key">
                    <i-input type="text" v-model="edit_course_data_type.name_key" placeholder="作为json或参数时候的key"></i-input>
                </FormItem>
                <Form-item label="级别" prop="level">
                    <Select v-model="edit_course_data_type.level" transfer placeholder="选择级别">
                        <!--<Option :value="0">0</Option>-->
                        <Option :value="1">1</Option>
                        <Option :value="2">2</Option>
                        <Option :value="3">3</Option>
                        <Option :value="4">4</Option>
                        <Option :value="5">5</Option>
                    </Select>
                </Form-item>
                <Form-item label="父级" prop="parent_id">
                    <Select v-model="edit_course_data_type.parent_id" transfer placeholder="选择父级">
                        <Option :value="0">无</Option>
                        <Option :value="parent_type.id" v-for="parent_type in parent_types" :key="parent_type.id">{{parent_type.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem label="数据类型">
                    <Select v-model="edit_course_data_type.data_type" transfer>
                        <Option value="decimal">小数</Option>
                        <Option value="int">整数</Option>
                        <Option value="percent">百分数</Option>
                        <Option value="string">字符串</Option>
                    </Select>
                </FormItem>
                <div class="edit-line line">
                    <Row>
                        <i-col span="5">
                            <Checkbox v-model="edit_course_data_type.fold">折叠</Checkbox>
                        </i-col>
                        <i-col span="5">
                            <Checkbox v-model="edit_course_data_type.is_manual">手动</Checkbox>
                        </i-col>
                        <i-col span="5">
                            <Checkbox v-model="edit_course_data_type.show_chart">图表</Checkbox>
                        </i-col>
                        <i-col span="9">
                            <span>顺序 </span>
                            <InputNumber size="small" :max="1000" :min="1" v-model="edit_course_data_type.sort_order"></InputNumber>
                        </i-col>
                    </Row>
                </div>
                <!--<FormItem label="是否手动">
                    <Checkbox v-model="edit_course_data_type.is_manual"></Checkbox>
                </FormItem>
                <FormItem label="顺序">
                    <InputNumber size="small" :max="1000" :min="1" v-model="edit_course_data_type.sort_order"></InputNumber>
                </FormItem>-->
            </Form>
        </Modal>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        data(){
            return {
                edit_course_data_type: {},
                new_course_data_type: {
                    parent_id: 0,
                    name: '',
                    name_tip: '',
                    name_key: '',
                    is_manual: true,
                    fold: false,
                    show_chart: true,
                    sort_order: 1000,
                    level: 1,
                    data_type: 'decimal'
                },
                course_data_types: [],
                level1_types: [],
                columns: [
                    {
                        title: '名称',
                        key: 'name'
                    },
                    {
                        title: '名称解释',
                        key: 'name_tip'
                    },
                    {
                        title: '手动输入?',
                        key: 'is_manual'
                    },
                    {
                        title: '数据类型',
                        key: 'data_type'
                    },
                    {
                        title: '操作',
                        render: (h, params)=>{
                            return h('Button', {
                                props: {
                                    size: 'small'
                                },
                                on: {
                                    click: ()=>{
                                        this.editCourseDataType(params.row);
                                    }
                                }
                            }, '编辑')
                        }
                    }
                ],
                edit_config: {
                    modal: false,
                    loading: true
                }
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            ...mapGetters({
                teams: 'async/root_teams',
                teams_hash: 'async/root_teams_hash',
            }),
            parent_types(){
                let level = this.edit_course_data_type.level;
                if(!level || level <= 0){
                    return [];
                }else{
                    let types = [];
                    this.course_data_types.forEach((type)=>{
                        if(type.level === (level - 1)){
                            types.push(type);
                        }
                    });
                    return types;
                }
            }
        },
        created(){
            this.getCourseDataTypes();
        },
        mounted(){
            //
        },
        methods: {
            getCourseDataTypes(){
                Util.ajax.get(Util.api.get_course_data_types).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.level1_types = res.data.course_data_types;
                        this.course_data_types = [];
                        this.genCourseDataTypes(this.level1_types);
                    }else{
                        //失败
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            genCourseDataTypes(types){
                types.forEach((type)=>{
                    this.course_data_types.push(type);
                    if(type.course_data_types){
                        this.genCourseDataTypes(type.course_data_types);
                    }
                });
            },
            editCourseDataType(course_data_type){
                this.edit_course_data_type = Util.clone(course_data_type);
                this.edit_config.modal = true;
            },
            updateCourseDataType(){
                Util.ajax.post(Util.api.update_course_data_type, this.edit_course_data_type).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.edit_config.modal = false;
                        this.getCourseDataTypes();
                        //Util.insertOrUpdateArrayItem(this.course_data_types, res.data.course_data_type);
                    }else{
                        this.resetLoading();
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.resetLoading();
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            resetLoading(){
                this.edit_config.loading = false;
                setTimeout(()=>{
                    this.edit_config.loading = true;
                }, 500);
            }
        }
    }
</script>
